<div class="sam-form-row">
   <label>{{ 'brick.brick_definitions.inner_wall_brick.settings.brick_wall' | translate }}</label>
   <div fxLayout="column">
      <div fxFlex="1 1 10%" fxLayout="row">
         <button
            (click)="toggleBrickSelectionDialog()"
            kendoTooltip
            [tooltipTemplate]="brickSelectionDialog"
            tooltipClass="tooltip-popup"
            #brickSelectionPopupControl
            #brickSelectionTooltipDirective="kendoTooltip"
            kendoButton
            showOn="none"
         >
            <fa-icon class="sam-margin-right" [icon]="addBrickIcon"></fa-icon>
            <div class="sam-button-text">
               {{ 'brick.brick_definitions.inner_wall_brick.settings.add_new_item_button' | translate }}
            </div>
         </button>
      </div>

      <gridster fxFlex="1 1 auto" [options]="options">
         <gridster-item
            *ngFor="let brickInstanceId of brickInstanceIds$ | async"
            [item]="brickInstanceId | brickIdToGridsterConfig$ | async"
         >
            <div class="inner-wall-item sam-padding" fxLayout="row" fxFlexFill>
               <div fxFlexAlign="center" fxLayout="column" fxFlex="1 1 100">
                  <div class="brick-title sam-margin">
                     <fa-icon
                        [icon]="(brickInstanceId | instanceIdToBrickDescription$ | async).definition.brickIcon"
                     ></fa-icon>
                     {{ brickInstanceId | instanceIdToBrickTitle$ | async }}
                  </div>
                  <div fxLayout="row" fxLayoutAlign="center center">
                     <samweb-brick-setting-button
                        class="sam-clickable sam-margin"
                        [brickInstanceId]="brickInstanceId"
                     ></samweb-brick-setting-button>
                     <fa-icon
                        class="sam-clickable sam-margin sam-red"
                        [icon]="removeBrickIcon"
                        (click)="removeBrickFromInnerWall(brickInstanceId)"
                     ></fa-icon>
                  </div>
               </div>
            </div>
         </gridster-item>
      </gridster>
   </div>
</div>

<ng-template #brickSelectionDialog>
   <samweb-add-brick-dialog
      [addingBrickSpecialHandlingByOtherBrickInstanceId]="brickInstanceId"
      (samwebOutsideClick)="closeBrickSelectionDialog()"
   ></samweb-add-brick-dialog>
</ng-template>
